/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type b2b_v1_connect_ConnectUpdate = {
    report_id: string;
    scope?: Array<'identity' | 'investments' | 'loans' | 'transactions'>;
    status: b2b_v1_connect_ConnectUpdate.status;
};
export namespace b2b_v1_connect_ConnectUpdate {
    export enum status {
        INITIALIZED = 'initialized',
        CONSENT_RECEIVED = 'consent_received',
        BANKS_SELECTED = 'banks_selected',
        COMMITTED = 'committed',
        PROCESSING = 'processing',
        COMPLETED = 'completed',
        ERROR = 'error',
    }
}

